import { IPlacemark } from '../placemarks.state/placemarks.model';
import { IBaseTour } from './baseTour.model';

export class SetBaseTour {
  static readonly type = '[BaseTour] Set Base Tour';
  constructor(public baseTour: IBaseTour) {}
}

export class ClearBaseTour {
  static readonly type = '[BaseTour] Clear Base Tour';
}

export class SetTourPlacemark {
  static readonly type: string = '[BaseTour] Set Placemark';

  constructor(public placemark: IPlacemark, public patchNewState: boolean = true) {}
}

export class SetMultipleTourPlacemarks {
  static readonly type: string = '[BaseTour] SetMultiple Placemarks';

  constructor(public placemarks: IPlacemark[]) {}
}

export class RemoveTourPlacemark {
  static readonly type: string = '[BaseTour] Remove Placemark';

  constructor(public placemarkId: string) {}
}

export class SetCurrentStepID {
  static readonly type = '[BaseTour] Set Current Step ID';
  constructor(public stepID: number | null) {}
}